<template>
  <div @keyup.13="submit">
    <mu-dialog
      title="编辑班次"
      width="500"
      :open="open"
      @close="close"
      class="update-dialog"
    >
      <mu-form :model="editForm" label-position="left" label-width="100">
        <mu-form-item prop="name" label="名称">
          <mu-text-field v-model="editForm.name"></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="isUsing" label="是否启用">
          <mu-radio
            :value="true"
            v-model="editForm.isUsing"
            label="是"
          ></mu-radio>
          <mu-radio
            :value="false"
            v-model="editForm.isUsing"
            label="否"
          ></mu-radio>
        </mu-form-item>

        <mu-form-item prop="isOvertime" label="是否加班">
          <mu-radio
            :value="true"
            v-model="editForm.isOvertime"
            label="是"
          ></mu-radio>
          <mu-radio
            :value="false"
            v-model="editForm.isOvertime"
            label="否"
          ></mu-radio>
        </mu-form-item>

        <mu-form-item prop="startTime" label="上班时间">
          <mu-text-field
            v-model="editForm.startTime"
            placeholder="格式：HH:MM或HH:MM:SS"
          ></mu-text-field>
        </mu-form-item>

        <mu-form-item prop="endTime" label="下班时间">
          <mu-text-field
            v-model="editForm.endTime"
            placeholder="格式：HH:MM或HH:MM:SS"
          ></mu-text-field>
        </mu-form-item>
      </mu-form>
      <mu-button slot="actions" flat color="secondary" @click="close"
        >取消</mu-button
      >
      <mu-button slot="actions" color="primary" @click="submit">提交</mu-button>
    </mu-dialog>
  </div>
</template>

<script>
import backend from 'utils/backend'
import api from '@/api'
export default {
  props: {
    open: {
      tpye: Boolean,
      default: false
    },
    form: {
      type: Object
    }
  },
  data() {
    return {
      editForm: {}
    }
  },
  methods: {
    submit() {
      backend(api.schedule.update, this.editForm).then((result) => {
        if (result.statusCode === 200) {
          this.close()
          this.$emit('finish')
        }
      })
    },
    close() {
      this.$emit('update:open', false)
    }
  },
  watch: {
    open(val) {
      if (val) {
        this.editForm = JSON.parse(JSON.stringify(this.form))
      }
    }
  }
}
</script>

<style lang="less" scoped>
.update-dialog {
}
</style>



// WEBPACK FOOTER //
// src/views/schedule/update.vue